import { Box, MenuItem, TextField } from "@mui/material";
import type { CostCenterOption } from "../models/SummaryByCloseDate";

interface Props {
	costCenters: CostCenterOption[];
	costCenterId: number | null;
	onCostCenterChange: (value: number | null) => void;
	closeDates: string[];
	closeDate: string | null;
	onCloseDateChange: (value: string | null) => void;
	closeDatesLoading: boolean;
}

export const SummaryByCloseDateToolbar = ({
	costCenters,
	costCenterId,
	onCostCenterChange,
	closeDates,
	closeDate,
	onCloseDateChange,
	closeDatesLoading,
}: Props) => (
	<Box
		sx={{
			display: "flex",
			alignItems: "center",
			gap: 1,
			px: 1.5,
			py: 0.75,
			flexWrap: "wrap",
		}}
	>
		<Box sx={{ width: 260 }}>
			<TextField
				select
				size="small"
				fullWidth
				label="Cost Center"
				value={costCenterId ?? ""}
				disabled={costCenters.length === 0}
				onChange={(event) =>
					onCostCenterChange(
						event.target.value === "" ? null : Number(event.target.value),
					)
				}
			>
				<MenuItem value="">Choose...</MenuItem>
				{costCenters.map((costCenter) => (
					<MenuItem key={costCenter.Id} value={costCenter.Id}>
						{costCenter.Description?.trim()
							? `${costCenter.Name} - ${costCenter.Description.trim()}`
							: costCenter.Name}
					</MenuItem>
				))}
			</TextField>
		</Box>

		<Box sx={{ width: 200 }}>
			<TextField
				select
				size="small"
				fullWidth
				label="Close Date"
				value={closeDate ?? ""}
				disabled={closeDatesLoading || closeDates.length === 0}
				onChange={(event) => onCloseDateChange(event.target.value || null)}
			>
				<MenuItem value="">Choose...</MenuItem>
				{closeDates.map((value) => (
					<MenuItem key={value} value={value}>
						{value}
					</MenuItem>
				))}
			</TextField>
		</Box>
	</Box>
);
